import * as React from 'react';
import * as styles from './skeleton-loader.module.scss';

const SkeletonLoader = ({ widths, className }) => {
    return (
        <div className={`${styles.skeletonLoader} ${className || ''}`}>
            {widths?.map((w, i) => (
                <div key={i} className={styles.skeletonPulse} style={{ width: w }}></div>
            ))}
        </div>
    );
}

export default SkeletonLoader;